module.exports = __webpack_public_path__ + "img/review-2.6e9ad0fa.png";